// Auto-generated at build time by scripts/prebuild_stamp.js.
// The ISO-timestamp value below is a literal string baked into
// the emitted bundle so the webpack content-hash of main.*.js
// cannot match any previous build — defeats the Emergent build
// cache's input-deduplication pass.
//
// Do NOT replace this with Date.now() or new Date() — those would
// resolve at runtime, leaving the on-disk bundle content
// unchanged across builds.
export const BUILD_VERSION = "2026-09-02T15:38:55.595Z";
